module.exports = __webpack_public_path__ + "static/media/BgLogo.2a305dfa.png";